import Api from 'api';

import {
  GET_EMPLOYEES_ASSETS_REPORT,
  SET_EMPLOYEES_ASSETS_REPORT_PAGINATION,
  SET_EMPLOYEES_ASSETS_REPORT_FILTERS,
  RESET_EMPLOYEES_ASSETS_REPORT,
} from 'reports/constants';

export const setEmployeesAssetsReportPagination = (payload) => ({
  type: SET_EMPLOYEES_ASSETS_REPORT_PAGINATION,
  payload,
});

export const setEmployeesAssetsReportFilters = (payload) => ({
  type: SET_EMPLOYEES_ASSETS_REPORT_FILTERS,
  payload,
});

export const getEmployeesAssetsReport = (
  companyId,
  subcompanyId,
  filters,
  limit,
  page,
  orderBy,
  order
) => ({
  type: GET_EMPLOYEES_ASSETS_REPORT,
  meta: { needAuth: true },
  payload: Api.reports.getEmployeesAssetsReport(
    companyId,
    subcompanyId,
    filters,
    limit,
    page,
    orderBy,
    order
  ),
});

export const resetEmployeesAssetsReport = () => ({
  type: RESET_EMPLOYEES_ASSETS_REPORT,
});



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/actions/employees_assets_report_actions.js